export default {"src":"/_next/static/media/user-light.4f396fe8.svg","height":17,"width":17};